import { render, staticRenderFns } from "./balance-moves-table.vue?vue&type=template&id=15d1ea23&"
import script from "./balance-moves-table.vue?vue&type=script&lang=ts&"
export * from "./balance-moves-table.vue?vue&type=script&lang=ts&"
import style0 from "./balance-moves-table.vue?vue&type=style&index=0&id=15d1ea23&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports